export const getWaterFlowData = (list) => {
  let leftList = []
  let rightList = []

  let heightleft = 0
  let heightright = 0

  list.map(res => {
    let scale = parseFloat(res.width) / 375
    let height = parseFloat(res.height) / scale > 600 ? 600 : parseFloat(res.height) / scale
    if (heightleft <= heightright) {
      leftList.push(res)
      heightleft += height
    } else {
      rightList.push(res)
      heightright += height
    }
  })
  return {
    leftList,
    rightList
  }
}
